import { render, staticRenderFns } from "./WxAutoReplyEditor.vue?vue&type=template&id=145c5fba"
import script from "./WxAutoReplyEditor.vue?vue&type=script&lang=js"
export * from "./WxAutoReplyEditor.vue?vue&type=script&lang=js"
import style0 from "./WxAutoReplyEditor.vue?vue&type=style&index=0&id=145c5fba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports